import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import emailjs from "@emailjs/browser";
import { CONTACTO, IconInstagram, IconMail, IconWhatsApp } from "../components/Social";
import "../styles/contacto.css";

const EMAILJS = { service: "service_qaqsqyl", template: "template_wqelvxn", publicKey: "DmK9GUmZIXUpqDple" };

export default function Contacto() {
    const formRef = useRef();
    const [status, setStatus] = useState("idle"); // idle | sending | ok | error

    const sendEmail = async (e) => {
        e.preventDefault();
        setStatus("sending");
        try {
            await emailjs.sendForm(EMAILJS.service, EMAILJS.template, formRef.current, { publicKey: EMAILJS.publicKey });
            formRef.current.reset();
            setStatus("ok");
        } catch (error) {
            console.error("EmailJS error:", error);
            setStatus("error");
        }
    };

    return (
        <div className="contacto page-top">
            <section className="contacto-info">
                <span className="eyebrow">Contacto</span>
                <h1 className="display">Hablemos<br />de tu <em>evento.</em></h1>
                <p className="contacto-lead">
                    Cuéntame qué deporte, fecha y lugar. Te respondo con disponibilidad y cotización,
                    normalmente el mismo día.
                </p>

                <a href={CONTACTO.whatsapp} className="btn btn-volt contacto-wa" target="_blank" rel="noreferrer">
                    <IconWhatsApp /> WhatsApp · {CONTACTO.telefono}
                </a>

                <ul className="contacto-canales">
                    <li><a href={`mailto:${CONTACTO.email}?subject=${encodeURIComponent("Fotografía deportiva")}`}><IconMail /> {CONTACTO.email}</a></li>
                    <li><a href={CONTACTO.instagram} target="_blank" rel="noreferrer"><IconInstagram /> @lorelyfotos_sports</a></li>
                    <li className="mono">{CONTACTO.ciudad} y área metropolitana</li>
                    <li><Link to="/pagar" className="contacto-pagar">¿Vas a pagar un anticipo? Ver datos para transferir →</Link></li>
                </ul>
            </section>

            <section className="contacto-form-wrap">
                <h2 className="mono">O déjame un mensaje</h2>
                <form className="contacto-form" ref={formRef} onSubmit={sendEmail}>
                    <label>
                        <span>Nombre</span>
                        <input type="text" name="name" autoComplete="name" required />
                    </label>
                    <label>
                        <span>Correo</span>
                        <input type="email" name="email" autoComplete="email" required />
                    </label>
                    <label>
                        <span>Teléfono <em>(opcional)</em></span>
                        <input type="tel" name="phone" autoComplete="tel" />
                    </label>
                    <label>
                        <span>Mensaje</span>
                        <textarea name="message" rows="5" placeholder="Ej. Final de liga, sábado 12 en Neza, 2 horas." required />
                    </label>

                    <button type="submit" className="btn btn-volt" disabled={status === "sending"}>
                        {status === "sending" ? "Enviando…" : "Enviar mensaje"}
                    </button>

                    <p className={`form-status ${status}`} role="status" aria-live="polite">
                        {status === "ok" && "¡Listo! Tu mensaje llegó. Te contesto pronto."}
                        {status === "error" && "No se pudo enviar. Intenta de nuevo o escríbeme por WhatsApp."}
                    </p>
                </form>
            </section>
        </div>
    );
}
